<template>
    <div class="container">
        <div class="jumbotron bg-info my-3">
            <h1 style="font-size:2rem;">
                <img src="images/logo.png" alt="" class="rounded-circle" width="72" height="72" />
                Announce ID: {{ announcementData.id }}
            </h1>
            <hr class="my-4">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h3 class="pb-2">{{ announcementData.announcement_name_en }}</h3>
                    <h6>Building {{ announcementData.announcement_building }} {{ announcementData.announcement_room_floor }} Floor Unit {{ announcementData.announcement_room_no }}</h6>
                    <h6>{{ announcementData.announcement_room_type }} {{ announcementData.announcement_room_size }} sqm. </h6>
                    <div class="pt-3" v-if="announcementData.announcement_type === 'Rent' || announcementData.announcement_type === 'Sell/Rent'">
                        <h6 class="font-weight-bold">For Rent</h6>
                        <h3>
                        <span class="font-weight-bold badge badge-danger">{{ announcementData.announcement_rental_monthly_price| currency('฿', 2) }}</span>
                        </h3>
                    </div>
                    <div class="pt-3" v-if="announcementData.announcement_type === 'Sell' || announcementData.announcement_type === 'Sell/Rent'">
                        <h6>For Sales</h6>
                        <h3 class="font-weight-bold">
                        <span class="font-weight-bold badge badge-danger">{{ announcementData.announcement_net_price| currency('฿', 2) }}</span>
                        </h3>
                    </div>
                </div>
                <div class="col-md-6 col-lg-5">
                    <figure class="snip0015 mx-auto">
                        <img :src="getImageDefault()" class="img-fluid"/>
                        <figcaption>
                            <h2><br /><div class="font-weight-bold pt-3">click here</div><br /><br /></h2>
                            <a href="#" v-on:click.prevent="showGallery()"></a>
                        </figcaption>			
                    </figure>
                </div>                
            </div>
        </div>
        <img class="image d-none" v-for="(image, i) in images" :src="image" :key="i">
        <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
    </div> 
    <!--container end.//-->
</template>

<script>
    export default {
        created: function() {
            let self = this;
            _.forEach(self.announcementData.path_files, function(value){
                self.images.push(_.replace(value.path_file, 'images', './storage/images'));
            });
        },
        components: {
            VueGallerySlideshow: window.VueGallerySlideshow
        },  
        methods: {
            getImageDefault: function() {
                let obj = _.find(this.announcementData.path_files, function(o) {
                    return o.is_default === '1';
                });

                return _.replace(obj.path_file, 'images', './storage/images');
            },
            showGallery: function() {
                this.index = 0;
            }
        },
        data: () => ({
            announcementData: JSON.parse(window.announcementData),
            images: [],
            index: null       
        })
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/frontend/AnnouncementComponent.vue